module.exports = __webpack_public_path__ + "img/calendar-year.5268caaf.svg";